var _path, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentMore2424 = function SvgCommentMore2424(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "comment_more_24_24_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M24 0v24H0V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#comment_more_24_24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F7070",
    d: "M5.942 12q0-.516.367-.883.368-.367.883-.367.516 0 .883.367.367.368.367.883 0 .516-.367.883t-.883.367-.883-.367A1.2 1.2 0 0 1 5.942 12m4.808 0q0-.516.367-.883.368-.367.883-.367.516 0 .883.367.367.368.367.883 0 .516-.367.883a1.2 1.2 0 0 1-.883.367q-.516 0-.883-.367A1.2 1.2 0 0 1 10.75 12m4.808 0q0-.516.367-.883t.883-.367.882.367q.368.368.368.883 0 .516-.368.883a1.2 1.2 0 0 1-.882.367q-.516 0-.883-.367a1.2 1.2 0 0 1-.367-.883"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#ECEEF0"
  })));
};
export default SvgCommentMore2424;